export const presets = {
  preview: {
    image: { maxWidth: '200px', maxHeight: '150px', borderRadius: '6px', objectFit: 'scale-down' },
    video: { maxWidth: '200px', maxHeight: '150px', borderRadius: '6px', objectFit: 'scale-down' },
    other: { maxWidth: '200px', maxHeight: '150px', borderRadius: '6px' },
  },
  input: {
    image: { maxWidth: '80px', maxHeight: '80px', borderRadius: '2px', objectFit: 'contain' },
    video: { maxWidth: '80px', maxHeight: '80px', borderRadius: '2px', objectFit: 'contain' },
    other: { maxWidth: '80px', maxHeight: '80px', borderRadius: '2px' },
  },
  files: {
    image: { maxWidth: '32px', maxHeight: '32px', borderRadius: '4px', objectFit: 'contain' },
    video: { maxWidth: '32px', maxHeight: '32px', borderRadius: '4px', objectFit: 'contain' },
    other: { maxWidth: '32px', maxHeight: '32px', borderRadius: '4px' },
  },
  fullscreen: {
    image: { maxWidth: '80vw', maxHeight: '85vh', borderRadius: '0px', objectFit: 'contain' },
    video: { maxWidth: '80vw', maxHeight: '85vh', borderRadius: '0px', objectFit: 'contain' },
    other: { maxWidth: '120px', maxHeight: '120px', borderRadius: '4px' },
  },
  post: {
    image: { maxWidth: '100%', maxHeight: '350px', borderRadius: '10px', objectFit: 'cover' },
    video: { maxWidth: '100%', maxHeight: '350px', borderRadius: '10px', objectFit: 'cover' },
    other: { maxWidth: '60px', maxHeight: '60px', borderRadius: '0px' },
  },
  editPost: {
    image: { maxWidth: '120px', maxHeight: '90px', borderRadius: '10px', objectFit: 'cover' },
    video: { maxWidth: '120px', maxHeight: '90px', borderRadius: '10px', objectFit: 'cover' },
    other: { maxWidth: '60px', maxHeight: '60px', borderRadius: '0px' },
  },
  editPostResponsive: {
    image: { maxWidth: '120px', maxHeight: '90px', borderRadius: '10px', objectFit: 'cover' },
    video: { maxWidth: '120px', maxHeight: '90px', borderRadius: '10px', objectFit: 'cover' },
    other: { maxWidth: '60px', maxHeight: '60px', borderRadius: '0px' },
  },
  postInput: {
    image: { maxWidth: '120px', maxHeight: '90px', borderRadius: '10px', objectFit: 'cover' },
    video: { maxWidth: '120px', maxHeight: '90px', borderRadius: '10px', objectFit: 'cover' },
    other: { maxWidth: '60px', maxHeight: '60px', borderRadius: '0px' },
  },
}
